type CountLineInput = {
  shown: number;
  total: number;
  filtered: boolean;
  lastUpdated: string | null;
  rosterNote?: string | null;
  rolledOver?: boolean;
};

export function rosterCountLine({
  shown,
  total,
  filtered,
  lastUpdated,
  rosterNote,
  rolledOver = false,
}: CountLineInput): string {
  const noun = shown === 1 ? 'student' : 'students';
  const count = `${shown} ${noun}`;
  if (filtered) return `${count} · filtered from ${total}`;
  if (rosterNote) return `${count} · ${rosterNote}`;
  if (lastUpdated == null) return count;
  return rolledOver
    ? `${count} · Showing your most recent upload · ${lastUpdated}`
    : `${count} · Last updated ${lastUpdated}`;
}
